import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchProductVariants,
  SearchProductVariantsVariables
} from "./types/SearchProductVariants";

export const searchProductVariants = gql`
  ${pageInfoFragment}
  query SearchProductVariants(
    $after: String
    $first: Int!
    $query: String!
    $productId: ID
  ) {
    search: productVariants(
      after: $after
      first: $first
      filter: { search: $query }
      productId: $productId
    ) {
      edges {
        node {
          id
          variantId
          name
          sku
          skuName
          price {
            amount
          }
          thumbnail {
            url
          }
          product {
            id
            name
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchProductVariants,
  SearchProductVariantsVariables
>(searchProductVariants);
